/**
 * Test IDs for QA automation.
 */
export const testIds = {
  customersListNewCustomer: "customers-list-new-customer",
} as const;
